export default {
  setSchemaList(state, payload) {
    state.schemaList = payload;
  },
  setSchemaDetails(state, payload) {
    state.schemaDetails = payload;
  },
  setPeriodicity(state, payload) {
    state.periodicity = payload;
  },
  toggleLoading(state, payload) {
    state.loading = payload;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-capacity-management/features/schema/store/mutations.js